import React from "react";
import { useNavigate } from "react-router-dom";

const industries = [
  {
    title: "Retail and Ecommerce",
    text: "Apps that help businesses sell products, manage customers, and improve shopping experiences.",
  },
  {
    title: "Food and Delivery",
    text: "Applications with ordering systems, delivery tracking, and customer notifications.",
  },
  {
    title: "Real Estate",
    text: "Apps for property listings, enquiries, virtual tours, and lead generation.",
  },
  {
    title: "Healthcare",
    text: "Solutions for appointments, patient communication, and digital services.",
  },
  {
    title: "Logistics",
    text: "Apps for tracking, route management, and field operations.",
  },
  {
    title: "Education",
    text: "Learning platforms, course apps, and student management solutions.",
  },
];

export default function Section7() {
  const navigate = useNavigate();

  return (
    <div className="w-full Section7 py-[35px] bg-[#F5F5F5]">
      <div className="container-1280 section7-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h2 className="text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[38px] text-center my-[0.67em] text-[#151515]">
          Industries We Build Mobile Apps For
        </h2>

        <p className="w-full md:w-[75%] mx-auto text-center leading-[22px] text-[#535353] text-sm md:text-base font-open mb-8">
          We create mobile applications for businesses across different
          industries, including:
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-8">
          {industries.map((item) => (
            <div key={item.title} className="bg-white rounded-[8px] p-5 border-t-[3px] border-[#cd2122]">
              <h3 className="text-[16px] font-bold text-[#151515] mb-2 font-open">{item.title}</h3>
              <p className="text-xs md:text-sm text-[#535353] leading-[20px] font-open">{item.text}</p>
            </div>
          ))}
        </div>

        <p className="w-full md:w-[75%] mx-auto text-center leading-[22px] text-[#535353] text-sm md:text-base font-open mb-6">
          If your industry is not on this list, that's fine. Tell us what
          you are building and we will tell you honestly whether it's a good
          fit for us.
        </p>

        <div className="text-center">
          <button
            onClick={() => navigate("/contact-mean3")}
            className="inline-block py-[12px] px-[30px] bg-[#cd2122] rounded-[3px] font-bold text-white border-none leading-[1.15] hover:bg-[#a81a1b] transition-colors"
          >
            Schedule a Call
          </button>
        </div>
      </div>
    </div>
  );
}
